/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WeekInReviewScrubber_rewindHistory = {
    readonly id: string;
    readonly snapshotDurationMillis: unknown;
    readonly snapshots: ReadonlyArray<{
        readonly snapshotMillis: unknown;
        readonly days: ReadonlyArray<{
            readonly workingHours: {
                readonly amBits: number;
                readonly pmBits: number;
            };
            readonly meetings: {
                readonly amBits: number;
                readonly pmBits: number;
            };
            readonly focusTime: {
                readonly amBits: number;
                readonly pmBits: number;
            };
            readonly lunch: {
                readonly amBits: number;
                readonly pmBits: number;
            };
            readonly fragmented: {
                readonly amBits: number;
                readonly pmBits: number;
            };
        } | null>;
    } | null>;
    readonly " $refType": "WeekInReviewScrubber_rewindHistory";
};
export type WeekInReviewScrubber_rewindHistory$data = WeekInReviewScrubber_rewindHistory;
export type WeekInReviewScrubber_rewindHistory$key = {
    readonly " $data"?: WeekInReviewScrubber_rewindHistory$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"WeekInReviewScrubber_rewindHistory">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amBits",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pmBits",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "WeekInReviewScrubber_rewindHistory",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "snapshotDurationMillis",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CompactCalendarSlotSnapshot",
                "kind": "LinkedField",
                "name": "snapshots",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "snapshotMillis",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DaySnapshot",
                        "kind": "LinkedField",
                        "name": "days",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SnapshotBits",
                                "kind": "LinkedField",
                                "name": "workingHours",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SnapshotBits",
                                "kind": "LinkedField",
                                "name": "meetings",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SnapshotBits",
                                "kind": "LinkedField",
                                "name": "focusTime",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SnapshotBits",
                                "kind": "LinkedField",
                                "name": "lunch",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SnapshotBits",
                                "kind": "LinkedField",
                                "name": "fragmented",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "RewindHistory",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '8add272e2714a79c1e76db71bf0b6315';
export default node;
